module.exports = __webpack_public_path__ + "static/media/speed.86e974d1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/black/speed.svg
// module id = 462
// module chunks = 0